import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { CertificateDto } from '@api/models/suppliers/CertificateDto';
import { EntityState } from '@api/models/enums/EntityState';
import { certificateService } from '@api/services/services';

type State = BaseType<CertificateDto>;

const initialState: State = {
  state: FetchState.None,
  data: {
    id: '',
    name: '',
    nameEn: '',
    expiryDateRequired: false,
    state: EntityState.Active,
    stateChangeEnabled: true,
  },
};

export const certificateSlice = baseSlice({
  name: 'certificate',
  initialState,
});

export const selectCertificateState = (state: RootState) => state.document.state;
export const selectCertificate = (state: RootState) => state.document.data;
export const certificateActions = certificateSlice.actions;

export const getCertificate = (documentId: string) => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return certificateService.getById(documentId);
  };

  getItem({
    dispatch,
    actions: certificateActions,
    getData: handleGetData,
  });
};
